import { jsx as _jsx } from "react/jsx-runtime";
import t from '../../lib/translate';
var Loading = function () { return _jsx("div", { children: t('general.loading') }); };
export default Loading;
